import React from 'react';
import { Apple, Play } from 'lucide-react';
import { LANDING } from '@/constants/testIds';
import PhoneMockup from './PhoneMockup';

const DASHBOARD_IMG =
    'https://customer-assets.emergentagent.com/job_hypertroop-fit/artifacts/u9nfc8e6_Dashboard.png';

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid={LANDING.heroSection}
            className="relative overflow-hidden pt-32 sm:pt-36 pb-24 sm:pb-28"
        >
            {/* Background grid */}
            <div className="absolute inset-0 hero-grid pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.05fr_0.95fr] gap-14 lg:gap-12 items-center">
                {/* LEFT — copy */}
                <div className="text-left">
                    {/* Eyebrow */}
                    <div
                        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1c1c1e] border border-white/10 text-xs text-[#8e8e93] mb-6 animate-fade-up"
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-[#b8ff00] animate-pulse" />
                        Now on iPhone
                    </div>

                    <h1
                        data-testid={LANDING.heroTitle}
                        className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-extrabold leading-[0.95] tracking-tight text-white mb-5 animate-fade-up delay-100"
                    >
                        HyperTroop<span className="text-[#b8ff00]">.Fit</span>
                    </h1>

                    <p
                        data-testid={LANDING.heroTagline}
                        className="text-xl sm:text-2xl text-white font-medium mb-3 animate-fade-up delay-200"
                    >
                        Train smarter, every day.
                    </p>

                    <p
                        data-testid={LANDING.heroSubline}
                        className="text-base sm:text-lg text-[#8e8e93] max-w-xl mb-9 leading-relaxed animate-fade-up delay-300"
                    >
                        The all-in-one personal fitness tracker — plan workouts,
                        log progress, track your body, and watch your gains
                        compound.
                    </p>

                    <div className="flex flex-wrap gap-3 animate-fade-up delay-400">
                        <a
                            href="https://apps.apple.com/in/app/hypertroop-fit/id6771863680"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={LANDING.heroCtaPrimary}
                            className="btn-primary-lime inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-sm font-bold"
                        >
                            <Apple size={18} fill="currentColor" />
                            Download on the App Store
                        </a>
                        <a
                            href="#how"
                            data-testid={LANDING.heroCtaSecondary}
                            className="btn-outline inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-sm font-semibold"
                        >
                            <Play size={14} />
                            See How It Works
                        </a>
                    </div>

                    {/* Inline mini-stats */}
                    <div className="mt-10 flex items-center gap-7 animate-fade-up delay-500">
                        <div>
                            <div className="text-[#b8ff00] font-bold text-xl">832+</div>
                            <div className="text-[11px] uppercase tracking-wider text-[#8e8e93]">
                                Exercises
                            </div>
                        </div>
                        <div className="w-px h-8 bg-white/10" />
                        <div>
                            <div className="text-[#b8ff00] font-bold text-xl">12</div>
                            <div className="text-[11px] uppercase tracking-wider text-[#8e8e93]">
                                Measurements
                            </div>
                        </div>
                        <div className="w-px h-8 bg-white/10" />
                        <div>
                            <div className="text-[#b8ff00] font-bold text-xl">7</div>
                            <div className="text-[11px] uppercase tracking-wider text-[#8e8e93]">
                                Data sections
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT — phone */}
                <div className="relative max-w-[340px] sm:max-w-[380px] mx-auto w-full animate-fade-up delay-300">
                    <PhoneMockup
                        testid={LANDING.heroMockup}
                        src={DASHBOARD_IMG}
                        alt="HyperTroop.Fit Dashboard"
                        className="relative"
                    />
                </div>
            </div>
        </section>
    );
};

export default Hero;
